import { connect } from 'react-redux';
import { assign } from 'lodash-es';
import PlayButton from '../components/PlayButton';
import { play } from '../actionCreators';
import { areInitialScreensPreloaded } from '../selectors/screen';
import { isAppleWatch } from '../selectors/project';
function mapStateToProps(state) {
    return {
        hasTouch: state.deviceDetection.hasTouch,
        isAppleWatch: isAppleWatch(state),
        isLoading: state.player.isAboutToPlay || !areInitialScreensPreloaded(state),
        projectID: state.project.config.id,
    };
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var newProps = {
        onClick: function () {
            if (!stateProps.isLoading) {
                dispatch(play(stateProps.projectID));
            }
        },
    };
    return assign({}, ownProps, stateProps, newProps);
}
export default connect(mapStateToProps, null, mergeProps)(PlayButton);
